/** A translucent tint of a palette colour, for tonal chips, alerts and focus rings. */
export const soft = (color: string, percent: number) => `color-mix(in srgb, ${color} ${percent}%, transparent)`;

export const STATUS_COLORS = ['primary', 'secondary', 'success', 'warning', 'error', 'info'] as const;

/** Corner radii: controls, then containers (cards, tables, dialogs). */
export const RADIUS = { control: 8, container: 12 } as const;
